import { atom } from "jotai";

import { WeatherConditionProps } from "@whoosh/design-system/src/components/display/WeatherCondition";

export const isMoveBooking_atom = atom<boolean>(false);

type WeatherConditionWithIndex = {
  index: number;
  condition: WeatherConditionProps | null;
};
export const visibleWeather_atom = atom<WeatherConditionWithIndex | null>(null);

export const possibleWeathers_atom = atom<WeatherConditionWithIndex[]>([]);

export const multiSlotRequestBookingInfoAtom = atom<{
  queueSlotId: string | null;
  requestedTime: string | null;
} | null>(null);
